import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
  dataTable: {
    borderCollapse: 'collapse',
    backgroundColor: '#FFFFFF',
    boxShadow:
      '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
    borderRadius: '5px 5px 0 0',
    width: '100%',
    minWidth: '1366px',

    '& thead tr:first-child': {
      '& th:first-child': {
        borderRadius: '4px 0 0 0',
      },
      '& th:last-child': {
        borderRadius: '0 4px 0 0',
      },
    },

    '& thead tr': {
      backgroundColor: theme.palette.grey[800],
      color: '#FFFFFF',
      textTransform: 'uppercase',

      '& th': {
        padding: '5px 5px',
        textAlign: 'center',
        fontSize: '0.8rem',
        width: 120,
      },

      '& middle-col': {
        whiteSpace: 'break-spaces',
        minWidth: 50,
        maxWidth: 52,
      },
    },

    '& tbody tr': {
      borderBottom: '1px solid rgba(224, 224, 224, 1)',

      '&:nth-child(even)': {
        backgroundColor: '#EFEFEF',
      },

      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.15)',
      },

      '& td': {
        padding: '0.4rem 0.3rem',
        fontSize: '1.2rem',
        textAlign: 'center',
        '@media only screen and (max-width : 1800px)': {
          fontSize: '1.1rem',
        },
        '@media only screen and (max-width : 1700px)': {
          fontSize: '1.0rem',
        },
        '@media only screen and (max-width : 1570px)': {
          fontSize: '0.9rem',
        },
      },

      '& td:nth-child(-n+5)': {
        width: 300,
      },
    },

    '& tfoot tr': {
      '& td': {
        padding: 10,
      },
    },
  },

  iconContent: {
    maxWidth: 70,
    minWidth: 70,
  },

  detailsContent: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  emptyTable: {
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'center',
  },

  score: {
    fontWeight: '900',
    fontSize: 12,
    color: '#222222',
    alignSelf: 'center',
    padding: '5px',
    borderRadius: 5,
    width: 'fit-content',
    margin: '0 auto',
  },

  scoreHeaders: {
    backgroundColor: theme.palette.grey[400],
    color: '#212121',
    minWidth: 70,
    textAlign: "center",
  },

  scoreRelatedHeader: {
    backgroundColor: theme.palette.grey[600],
    color: '#FFFFFF',
    borderRight: '1px solid #FFF',
  },

  bgcHeaders: {
    backgroundColor: theme.palette.grey[400],
    color: '#212121',
    minWidth: 70,
    textAlign: "center",
  },

  bgcRelatedHeader: {
    backgroundColor: theme.palette.grey[600],
    color: '#FFFFFF',
    borderRight: '1px solid #FFF',
    textAlign: "center",
  },

  rfcHeaders: {
    backgroundColor: theme.palette.grey[400],
    color: '#212121',
    textAlign: "center",
  },

  rfcRelatedHeader: {
    backgroundColor: theme.palette.grey[600],
    color: '#FFFFFF',
  },

  manualAnalisysHeader: {
    backgroundColor: theme.palette.grey[800],
    height: '1.5rem',
    color: '#FFFFFF',
  },

  nameHeader: {
    minWidth: 170,
  },

  cpfHeader: {
    minWidth: 95,
  },
  
  iconButton: {
    padding: 5,
  },

  tooltipText: {
    fontSize: 12,
  },

  noMaxWidth: {
    maxWidth: 'none',
  },

  cursorPointer: {
    cursor: 'pointer',
  },

  statusTooltip: {
    fontSize: 12,
    '.MuiTooltip-popper': {
      transform: 'rotate(-90deg)',
    },
  },

  modal: {
    display: 'flex',
    backgroundColor: '#FFFFFF',
    minHeight: 150,
    borderRadius: '10px',
    width: '90vw',
    height: '90vh',
    padding: '50px 40px 20px 40px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    fontSize: 14,
  },

  defaultCursor: {
    cursor: 'default',
  },

}))
